import * as React from "react";
const SvgFiRrIceCream = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M16.9 4.02a5.008 5.008 0 0 0-9.8 0 5.506 5.506 0 0 0-4.325 8.257l6.244 10.056a3.52 3.52 0 0 0 5.96 0l6.26-10.08A5.507 5.507 0 0 0 16.9 4.02M20 9.5q-.003.29-.056.573a34.7 34.7 0 0 1-6.624.884C11.329 5.647 19.593 3.842 20 9.5M12 2a3 3 0 0 1 2.893 2.25A5.52 5.52 0 0 0 12 6.34 5.52 5.52 0 0 0 9.107 4.25 3 3 0 0 1 12 2M7.5 6a3.517 3.517 0 0 1 3.18 4.955 36 36 0 0 1-6.623-.88A3.5 3.5 0 0 1 7.5 6m5.778 15.286a1.54 1.54 0 0 1-2.558 0l-5.55-8.94c4.514.826 9.141.826 13.656 0z"
    />
  </svg>
);
export default SvgFiRrIceCream;
